export default __webpack_public_path__ + "static/media/item-workplace.776df71f.jpg";